import { Record } from 'immutable';
const defaults = {
  seatNames: []
};
export default Record(defaults, 'AppUser');